import { render, staticRenderFns } from "./IconArrowDownBold.vue?vue&type=template&id=32503e15&"
import script from "./IconArrowDownBold.vue?vue&type=script&lang=js&"
export * from "./IconArrowDownBold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports